import { paths } from 'routes';
import { XHTTP } from 'services/api';

const END_POINTS = {
  ...paths.api.positionedWorkshop,
};

const PositionedWorkshopApi = {
  getList: (campaign, site) => XHTTP(`${END_POINTS.list}?campaign=${campaign}&site=${site}`),

  getSpecific: id => XHTTP(`${END_POINTS.get}${id}`),

  create: fields => XHTTP(END_POINTS.create, { method: 'post', body: fields }),

  update: (id, fields) => XHTTP(`${END_POINTS.edit}${id}`, { method: 'put', body: fields }),

  delete: id => XHTTP(`${END_POINTS.delete}${id}`, { method: 'delete' }),

  getEntitiesList: id => XHTTP(`${END_POINTS.getEntitiesList}${id}`),

  updateEntitiesList: (id, fields) => XHTTP(`${END_POINTS.editEntitiesList}${id}`, { method: 'put', body: fields }),
};

export { PositionedWorkshopApi };
